﻿"use strict";

/* Change the options in a select (drop down) */
window.replaceOptions = function (selectId, leaveFirst, newOptions) {
	try {
		var el = $('#' + selectId);
		var value = el.val();
		if (leaveFirst)
			$('#' + selectId + ' option:gt(0)').remove();
		else
			$('#' + selectId + ' option').remove();
		var $el = $("#" + selectId);
		$.each(newOptions, function (value, text) {
			$el.append($("<option></option>").attr("value", value).text(text));
		});
		// Reset the value if it exists in the new values as well
		if (value && $("#" + selectId + " option[value='" + value + "']").length > 0)
			el.val(value);
	} catch (ex) {
		console.error(ex);
	}
};

/* Change the options in one drop down based on the selection in another */
window.declareDependentDropDowns = function (selectId, dependentId, optionsDict) {
	$('#' + selectId).change(function () {
		var newOptions = {};

		for (var i = 0; i < optionsDict.length; i += 1) {
			if (optionsDict[i].value === this.value) {
				newOptions = optionsDict[i].options;
				break;
			}
		}

		replaceOptions(dependentId, true, newOptions);
	});

	$('#' + selectId).change();	// Execute once
};

window.closestOfClass = function (element, dependentSelector) {
	if (dependentSelector)
		return element.closest(dependentSelector);
	return element;
};

/* Shows and hides elements based on the data attribute of a select (drop down) */
window.declareElementVisibleForSelectValueDataAttribute = function (selectId, dependentId, dependentSelector, attributeName, visibleOptions, ignoreIfValuePresentInElementIds, triggerChangeForOptionNoneOtherElementIds) {
	dependentId = '#' + dependentId;

	$('#' + selectId).change(function () {
		var duration = AnimationManager.getCurrentDuration();
		var ignore = false;
		for (var i = 0; i < ignoreIfValuePresentInElementIds.length; i += 1) {
			if ($('#' + ignoreIfValuePresentInElementIds[i]).val()) {
				ignore = true;
				break;
			}
		}
		if (ignore !== true) {
			var currentSelected = $(this).children("option:selected");
			// Radio button groups (created using method StandardRadioBoxButtonGroupFor) do not provide the value directly
			var attribute = currentSelected.attr('data-' + attributeName);
			if (attribute) {

				var dependent = $(dependentId);
				if ($.inArray(attribute, visibleOptions) < 0 && attribute) {
					closestOfClass(dependent, dependentSelector).hide(duration, function () {
					});
				} else {
					// To revalidate on show (because otherwise it shows the error in some situations, e.g. when showing the element) put dependent.valid(); in the completed function below
					// However, if enabled, it will cause some agressive errors, e.g. when a new license is created and language proficiency is selected as type, the level immediately shows an error without giving the user a chance to enter something
					closestOfClass(dependent, dependentSelector).show(duration, function () {
					});
				}
			}
		}

		for (var i = 0; i < triggerChangeForOptionNoneOtherElementIds.length; i += 1) {
			$('#' + triggerChangeForOptionNoneOtherElementIds[i]).change();
		}
	});

	$('#' + selectId).change();	// Execute once
};
/* Shows and hides elements based on the value in a select (drop down) */
window.declareElementVisibleForSelectValues = function (selectId, dependentId, dependentSelector, visibleOptions) {
	dependentId = '#' + dependentId;
	$('#' + selectId).on('change', function () {
		var duration = AnimationManager.getCurrentDuration();
		var $this = $(this);

		// Radio button groups (created using method StandardRadioBoxButtonGroupFor) do not provide the value directly
		var val = $this.is(':checkbox') ? $this.prop('checked').toString() : this.value;
		if (val === undefined && this.tagName === "DIV") {
			val = $('input:radio[name=' + selectId + ']:checked').val();
		}
		var dependent = $(dependentId);
		if ($.inArray(val, visibleOptions) < 0) {
			closestOfClass(dependent, dependentSelector).hide(duration, function () {
			});
		} else {
			// To revalidate on show (because otherwise it shows the error in some situations, e.g. when showing the element) put dependent.valid(); in the completed function below
			// However, if enabled, it will cause some agressive errors, e.g. when a new license is created and language proficiency is selected as type, the level immediately shows an error without giving the user a chance to enter something
			closestOfClass(dependent, dependentSelector).show(duration, function () {
			});
		}
	});

	$('#' + selectId).change();	// Execute once
};

/* Shows and hides elements based on the value of the checkbox */
window.declareElementVisibleForCheckedCheckBox = function (checkboxId, dependentId) {
	dependentId = '#' + dependentId;
	$('#' + checkboxId).change(function () {
		var duration = AnimationManager.getCurrentDuration();
		var dependent = $(dependentId);
		if (this.checked) {
			dependent.closest('.form-group').show(duration, function () {
			});
		} else {
			dependent.closest('.form-group').hide(duration, function () {
			});
		}
	});
	$('#' + checkboxId).trigger('change');	// Execute once
};

window.setDataRangeValidatorDynamically = function (upperLimit, targetId, isTime = false) {
	// Workaround to dynamically change the jQuery validator when number of e.g. landings changes.
	// since the validator is loaded once at page load, just changing attributes does not work and custom rules have to be applied
	upperLimit = parseInt(upperLimit);
	var targetElement = $('#' + targetId);

	var msg = null;
	if (isTime === false) {
		msg = targetElement.attr("data-val-range");
		msg = msg.replace(/\d+$/, upperLimit);

		targetElement.rules("remove", "range");
		targetElement.rules("add", {
			range: [0, upperLimit],
			messages: {
				range: msg
			}
		});
	}
	else {
		msg = targetElement.attr("data-val-regex");
		msg = msg.replace(/\d+$/, upperLimit.toDurationString(true, false));
		targetElement.rules("remove", "regex");
		targetElement.rules("add", {
			range: [0, upperLimit],
			messages: {
				range: msg
			}
		});
	}
	// make target lose focus to trigger validator
	targetElement.blur();
};

window.showElementForCheckboxAndSelectValue = function (dependentId, checkboxId, selectVal, visibleOptions) {
	var duration = 300;
	var dependent = $(dependentId);
	if ($.inArray(selectVal, visibleOptions) >= 0 && $('#' + checkboxId).is(':checked')) {
		dependent.closest('.form-group').show(duration, function () {
		});
	}
	else {
		dependent.closest('.form-group').hide(duration, function () {
		});
	}
};

window.declareElementVisibleForSelectValueAndCheckBox = function (selectId, dependentId, checkboxId, visibleOptions) {
	dependentId = '#' + dependentId;
	$('#' + selectId).change(function () {
		var selectVal = $('#' + selectId).val();
		showElementForCheckboxAndSelectValue(dependentId, checkboxId, selectVal, visibleOptions);
	});
	$('#' + checkboxId).change(function () {
		var selectVal = $('#' + selectId).val();
		showElementForCheckboxAndSelectValue(dependentId, checkboxId, selectVal, visibleOptions);
	});
	$('#' + selectId).change();	// Execute once
	$('#' + checkboxId).change();	// Execute once

};

/* Moves an element before another one if it is not already before it */
window.moveBefore = function (elementId, otherId, duration) {
	var element = $('#' + elementId).closest('.form-group');
	var other = $('#' + otherId).closest('.form-group');
	// Check if visible
	if (element.is(":visible") && other.is(":visible")) {
		var isBefore = element.nextAll().filter(other).length !== 0;
		if (!isBefore) {
			if (!AnimationManager.animationsEnabled)
				duration = 0;
			// Revalidate on show because otherwise it shows the error in some situations, e.g. when showing the element
			element.insertBefore(other).hide().show(duration, function () { $('#' + elementId).valid(); });
		}
	}
};

/* Shows and hides elements based on the value in a select (drop down) */
window.declareElementBeforeAnotherForSelectValues = function (selectId, elementId, otherId, visibleOptions) {
	$('#' + selectId).change(function () {
		// Radio button groups (created using method StandardRadioBoxButtonGroupFor) do not provide the value directly
		var val = this.value;
		if (val === undefined && this.tagName === "DIV") {
			val = $('input:radio[name=' + selectId + ']:checked').val();
		}
		if ($.inArray(val, visibleOptions) < 0)
			moveBefore(elementId, otherId);
	});

	$('#' + selectId).change();	// Execute once
};

/*Combines the functionalities of declareElementVisibleForSelectValues and declareElementBeforeAnotherForSelectValues into one call.
The moveBefore logic has been moved into the body of the show callback to ensure sequential animation and prevent race conditions.*/
window.declareElementVisibleForSelectValuesBeforeAnother = function (selectId, elementId, selectOptions, otherId, visibleOptions) {
	var dependentId = '#' + elementId;
	$('#' + selectId).change(function () {
		var duration = AnimationManager.getCurrentDuration();

		// Radio button groups (created using method StandardRadioBoxButtonGroupFor) do not provide the value directly
		var val = this.value;
		if (val === undefined && this.tagName === "DIV") {
			val = $('input:radio[name=' + selectId + ']:checked').val();
		}
		var dependent = $(dependentId);
		if ($.inArray(val, selectOptions) < 0) {
			closestOfClass(dependent, '.form-group').hide(duration, function () {
			});
		} else {
			closestOfClass(dependent, '.form-group').show(duration, function () { /*dependent.valid();*/ });//Revalidate on show because otherwise it shows the error in some situations, e.g. when showing the element
			if ($.inArray(val, visibleOptions) < 0) {
				var element = $('#' + elementId).closest('.form-group');
				var other = $('#' + otherId).closest('.form-group');
				var isBefore = element.nextAll().filter(other).length !== 0;
				if (!isBefore) {
					// Revalidate on show because otherwise it shows the error in some situations, e.g. when showing the element
					element.insertBefore(other).hide().show(duration, function () { /*$('#' + elementId).valid();*/ });
				}
			}
		}
	});

	$('#' + selectId).change();	// Execute once
};

/* Enable/disable elements based on other element selection */
window.declareElementDisabledForNonNullValuesInAnother = function (selectId, elementId) {
	$('#' + selectId).change(function () {
		var element = document.getElementById(elementId);
		if ($(this).val())
			element.disabled = true;
		else
			element.disabled = false;
	});

	// Execute the change event once to handle editing attempts
	$('#' + selectId).trigger("change");
};
/* END: Enable/disable elements based on other element selection */

// InputControlExtensions
function InputControlExtensions() {
}

InputControlExtensions.setChecked = function (elementId, value) {
	var elementById = document.getElementById(elementId);
	var elementsByName = document.getElementsByName(elementId);	// There is a hidden element with the same name for disabled checkboxes

	var valueStr = value.toString();
	valueStr = valueStr.toLowerCase();
	if (valueStr === "true") {
		if (elementById)
			elementById.checked = true;
		elementsByName.forEach(function (element, index) {
			if (element.nodeName === "INPUT" && element.type === "hidden") {
				element.value = "true";
			}
		});
	} else {
		if (elementById)
			elementById.checked = false;
		elementsByName.forEach(function (element, index) {
			if (element.nodeName === "INPUT" && element.type === "hidden") {
				element.value = "false";
			}
		});
	}
};

InputControlExtensions.setDisabled = function (elementId, value) {
	var elementById = document.getElementById(elementId);

	if (elementById) {
		var $parent = $(elementById).closest('.custom-checkbox, .custom-radio-button');

		var valueStr = value.toString();
		valueStr = valueStr.toLowerCase();
		if (valueStr === "true") {
			elementById.disabled = true;
			$parent.addClass('disabled');
		} else {
			elementById.disabled = false;
			$parent.removeClass('disabled');
		}
	}
};

window.InputControlExtensions = InputControlExtensions;